import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Form, Input, Label } from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import './EncryptPassword.scss';
import Icon from '@mdi/react';
import { mdiContentCopy, mdiEye, mdiEyeOffOutline } from '@mdi/js';
import { initialValues, validationSchema } from './constants';
import { encryptString } from '../../../utils/encrypt.util';
import keyIcon from '../../../assets/icons/passwordKeyGray.png';

function EncryptPassword() {
  const [encryptedPassword, setEncryptedPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const onSubmit = data => {
    // Handle form submission
    const encryptedPwd = encryptString(data.password);
    setEncryptedPassword(encryptedPwd);
  };

  // Copy to clipboard function
  const copyToClipboard = async text => {
    if (!text) return;

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);

    textarea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      toast.error('Failed to copy to clipboard', {
        className: 'toast-error',
      });
    }
    document.body.removeChild(textarea);
  };

  return (
    <div className="page-content">
      <div className="ep-header p-3">
        <h5>Encrypted Password</h5>
      </div>
      <div className="d-flex align-items-center justify-content-center flex-column mt-5">
        <div style={{ width: '350px', maxWidth: '100%' }}>
          <Form
            className="d-flex flex-column gap-4"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div>
              <Label>
                Password<span className="text-danger">*</span>
              </Label>
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <div style={{ position: 'relative' }}>
                    <Input
                      {...field}
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Enter Password"
                      className={`external-filter-input form-control ${errors.password && 'is-invalid'} input-icon`}
                    />
                    <Button
                      className={`non-btn suffix-icon-btn ${errors.password && 'd-none'}`}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }}
                      type="button"
                      onClick={togglePasswordVisibility}
                    >
                      <Icon
                        path={showPassword ? mdiEyeOffOutline : mdiEye}
                        size={0.7}
                        color="#017EBD"
                      />
                    </Button>
                  </div>
                )}
              />
              {errors.password && (
                <div className="text-danger">{errors.password.message}</div>
              )}
            </div>

            <button type="submit" className="custom-btn">
              Encrypt Password
            </button>
            <div>
              <Label>Encrypted Password</Label>
              <div className="input-icon-group">
                <img
                  className="prefix-icon"
                  width={18}
                  height={18}
                  src={keyIcon}
                  alt="key"
                />
                <Input
                  type="text"
                  value={encryptedPassword || ''}
                  placeholder="Encrypted Password"
                  className="form-control input-icon external-filter-input"
                  readOnly
                />
                <button
                  type="button"
                  className="suffix-icon-btn"
                  onClick={() => copyToClipboard(encryptedPassword)}
                >
                  <Icon path={mdiContentCopy} size={0.7} color="#017EBD" />
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default EncryptPassword;
